import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIModal from 'UIComponents/dialog/UIModal'; // @ts-expect-error importing from JS file

import { saveUserAttribute } from 'AdsUI/actions/UserAttributesActions'; // @ts-expect-error importing from JS file

import { SEEN_FACEBOOK_CAPI_LCS_MODAL } from 'AdsUI/data/UserAttributesData'; // @ts-expect-error importing from JS file

import { getHubSpotUserId } from 'AdsUI/selectors/AuthSelectors';

const FacebookCapiModal = ({
  close,
  actionRequired
}) => {
  const dispatch = useDispatch();
  const userId = useSelector(getHubSpotUserId);
  const history = useHistory();
  useEffect(() => {
    return () => {
      // We only want the user to see this modal once
      dispatch(saveUserAttribute(SEEN_FACEBOOK_CAPI_LCS_MODAL, userId, true));
    };
  }, [dispatch, userId]);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    children: [/*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetBottom: -15,
      offsetTop: 35,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        alt: I18n.text('events.announcement.facebookCapi.imageAltText'),
        name: "announcement",
        width: "100%"
      })
    }), /*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "text-center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `events.announcement.facebookCapi.${actionRequired ? 'actionNeeded' : 'noActionNeeded'}.modalTitle`
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: close
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `events.announcement.facebookCapi.${actionRequired ? 'actionNeeded' : 'noActionNeeded'}.information`
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `events.announcement.facebookCapi.${actionRequired ? 'actionNeeded' : 'noActionNeeded'}.syncingNotice`
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [!actionRequired && /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: close,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "events.announcement.facebookCapi.noActionNeeded.confirmButton"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: actionRequired ? 'primary' : 'secondary',
        onClick: () => {
          history.push('/events');
          close();
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "events.announcement.facebookCapi.noActionNeeded.goToEventsButton"
        })
      })]
    })]
  });
};

export default FacebookCapiModal;